import { reducers } from 'redux/core'
import request from 'sb-request'
import actions from 'redux/actions'
import { constants } from 'common/helpers'

import { callVindicia } from './util'
import { buySubscription, beginSubscriptionUsingPayPal, commitSubscriptionUsingPayPal,
  beginSubscriptionUsingApplePay, commitSubscriptionUsingApplePay, postponedSubscriptionProcessing } from './buySubscription'
import { buyOrder, beginPaymentUsingPayPal, commitPaymentUsingPayPal,
  beginPaymentUsingApplePay, commitPaymentUsingApplePay, fetchCanBuyInOneClickStatus, buyOrderInOneClick } from './buyOrder'
import { buyGiftSubscription, beginGiftSubscriptionUsingPayPal, commitGiftSubscriptionUsingPayPal } from './buyGiftSubscription'
import { buyGiftCard, beginGiftCardUsingPayPal, commitGiftCardUsingPayPal } from './buyGiftCard'
import redeemGiftSubscription from './redeemGiftSubscription'
import { redeemCoupon, redeemCouponNoCharge, beginRedeemCouponUsingPayPal, commitRedeemCouponUsingPayPal } from './redeemCoupon'


const update                  = (data) => reducers.models.payment.update(data)
const updatePaymentOption     = (option) => reducers.models.payment.updatePaymentOption(option)
const setUnpause              = (value) => reducers.models.payment.setUnpause(value)
const setUserShippingAddress  = (data) => reducers.models.payment.setUserShippingAddress(data)

const setIsFacebookMixLandingCampaign = (value) => {
  if (value) {
    actions.misc.cookies.setItem(constants.cookieNames.isFacebookMixLandingCampaign, value)
  }
  else {
    actions.misc.cookies.removeItem(constants.cookieNames.isFacebookMixLandingCampaign)
  }

  reducers.models.payment.setIsFacebookMixLandingCampaign(value)
}

const fetchOrderListIds = (orderNumber) =>
  request.get(`rest/order/${orderNumber}/ids`, {
    withErrorModal: false,
  })

const fetchPostponedSubscriptionProcessing = () => (
  request.post('graphql?name=subscriptionProgress', {
    withErrorModal: false,
    body: {
      query: `{
        user {
          subscriptionProgress {
            status
            subscriptionSessionId
          }
        }
      }`,
    },
  }).then(({ user: { subscriptionProgress } = {} }) => {
    reducers.models.payment.update({ subscriptionProgress })
  })
)

const setSubscriptionCaseStatus = (status) => {
  reducers.models.payment.setSubscriptionCaseStatus(status)

  if (status) {
    return actions.misc.cookies.setSessionItem(
      constants.cookieNames.casesSubscription, true, { expires: 1 }
    )
  }

  actions.misc.cookies.removeItem(constants.cookieNames.casesSubscription)
}


export default {
  update,
  updatePaymentOption,
  setUnpause,
  setIsFacebookMixLandingCampaign,
  setUserShippingAddress,
  fetchOrderListIds,
  setSubscriptionCaseStatus,
  fetchPostponedSubscriptionProcessing,

  buySubscription,
  beginSubscriptionUsingPayPal,
  commitSubscriptionUsingPayPal,
  beginSubscriptionUsingApplePay,
  commitSubscriptionUsingApplePay,
  postponedSubscriptionProcessing,

  buyOrder,
  beginPaymentUsingPayPal,
  commitPaymentUsingPayPal,
  beginPaymentUsingApplePay,
  commitPaymentUsingApplePay,
  fetchCanBuyInOneClickStatus,
  buyOrderInOneClick,

  buyGiftSubscription,
  beginGiftSubscriptionUsingPayPal,
  commitGiftSubscriptionUsingPayPal,

  buyGiftCard,
  beginGiftCardUsingPayPal,
  commitGiftCardUsingPayPal,

  redeemGiftSubscription,
  redeemCoupon,
  redeemCouponNoCharge,
  beginRedeemCouponUsingPayPal,
  commitRedeemCouponUsingPayPal,

  callVindicia,
}
